import {
  Button,
  Buttons,
  Div,
  Modal,
  ModalBackground,
  ModalCard,
} from "trunx";

import { ReactNode } from "react";
import { useCookie } from "react-use";

interface DisclaimerProps {
  children: ReactNode;
  outLink: string;
}
const Disclaimer = ({ children, outLink }: DisclaimerProps) => {
  const [accepted, setAccepted] = useCookie("disclaimer");


  const head = (<Div bulma="modal-card-title">Disclaimer</Div>);
  const foot = (
    <Buttons>
      <Button bulma="is-primary" onClick={() => setAccepted("accepted")}>
        Accept
      </Button>
      <Button onClick={() => (window.location.href = outLink)}>
        Home page
      </Button>
    </Buttons>
  );
  return (
    <Modal isActive={!accepted}>
      <ModalBackground />
      <ModalCard head={head} foot={foot}>
        <Div bulma="modal-card-body">{children}</Div>
      </ModalCard>
    </Modal>
  );
};

export default Disclaimer;
